export type InvestmentPrioritySelectionState = {
  minimum: boolean;
  balanced: boolean;
  maximum: boolean;
};

export type InvestmentPrioritySelectionAction = {
  type: InvestmentPrioritySelectionType;
};

export enum InvestmentPrioritySelectionType {
  Minimum = "minimum",
  Balanced = "balanced",
  Maximum = "maximum",
}
